import { get } from '@core/api/baseApi';
import { GetPermissionsResponse } from '@core/types';
import { Filters } from '../types/Filters';

const getPermissions = async (filters: Filters): Promise<GetPermissionsResponse> =>
  await get(`/permissions`, { params: filters });

export default getPermissions;
